import { render, staticRenderFns } from "./LoginButton.vue?vue&type=template&id=71820f4a&scoped=true"
import script from "./LoginButton.vue?vue&type=script&lang=js"
export * from "./LoginButton.vue?vue&type=script&lang=js"
import style0 from "./LoginButton.vue?vue&type=style&index=0&id=71820f4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71820f4a",
  null
  
)

export default component.exports